module.exports = __webpack_public_path__ + "static/media/increase-symbol.43ee5ed7.svg";